const FALLBACK_LANGUAGE = 'en'

/**
 * Extracts a 2-3 letter ISO 639 language code (e.g. `'en'`, `'de'`) from a
 * BCP-47 tag or an `Accept-Language` header value. Falls back to `'en'` for
 * unparseable input.
 */
export const toLanguageCode = (raw: string | null | undefined): string => {
  if (!raw || typeof raw !== 'string') return FALLBACK_LANGUAGE

  const baseLocale = raw.split(',')[0].split('-')[0].toLowerCase().trim()

  if (!/^[a-z]{2,3}$/.test(baseLocale)) {
    return FALLBACK_LANGUAGE
  }

  return baseLocale
}

/**
 * Returns the user's preferred language as a 2-3 letter ISO 639 code
 * (e.g. `'en'`, `'de'`). Intended as the web counterpart to what the iOS
 * client sends as `Locale.current.identifier`, stripped to the language part.
 *
 * Uses `navigator.language` on the client and the request's `Accept-Language`
 * header during SSR.
 */
export const getRequestLanguageCode = (): string => {
  if (import.meta.server) {
    const headers = useRequestHeaders(['accept-language'])
    return toLanguageCode(headers['accept-language'])
  }

  return toLanguageCode(navigator.language)
}
